function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import OnePagerWithImageContentComponent from "components/templates/one-pager-with-image-template/one-pager-with-image-content/one-pager-with-image-content-component";
import { StyledOnePagerWithImageComponent } from "./one-pager-with-image-component.scss";
class OnePagerWithImageComponent extends PureComponent {
    render() {
        return /*#__PURE__*/ _jsx(StyledOnePagerWithImageComponent, {
            className: "one-pager-with-image-component",
            children: /*#__PURE__*/ _jsx(OnePagerWithImageContentComponent, _object_spread({}, this.props))
        });
    }
    constructor(props){
        super(props);
    }
}
export { OnePagerWithImageComponent as default };
OnePagerWithImageComponent.defaultProps = {
    imageWithBackgroundPart: {
        backgroundColor: "brand-blue",
        src: "/static/img/boards/board-with-pencils.png",
        alt: "",
        imageSegmentHeight: "100vh"
    },
    textPart: {
        titleLines: [
            "Project Management",
            "<b>is better when it's visual</b>"
        ],
        subtitleLines: [
            "See what everyone on your team is working on in a single glance"
        ],
        bullets: [
            "Manage your projects & tasks with ease",
            "Plan visually on a timeline",
            "Centralize communication in one place"
        ],
        mobileTitleLines: [
            "Project Management",
            "<b>is better when it's visual</b>"
        ],
        mobileSubtitleLines: [
            "See what everyone on your team",
            "is working on in a single glance"
        ],
        color: "black"
    },
    signupForm: {
        buttonColor: "brand-pink",
        buttonText: "Get Started",
        inputPlaceholder: "Enter your work email",
        downloadButtonTitle: "Download The App"
    }
};
